/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React from "react";
import { BEM } from "@adapptio/lib-components";
import { FieldFloatingPanel, IFieldFloatingPanelProps } from "@adapptio/lib-editor-ui";
import { FC_ANCHOR, FC_DIRECTION, FC_SIZE } from "../FloatingContainer";
import { FIELD_FLOATING_PANEL_SCHEMA, FIELD_FLOATING_PANEL_STYLE } from "../Fields/FieldFloatingPanel";
import { PreviewResolutionSettingsForm } from "../PreviewResolutionSettingsForm";

export interface IPreviewResolutionSettingsProps {
	className?: string;
	open: boolean;
	target: IFieldFloatingPanelProps["for"];
	onClose: IFieldFloatingPanelProps["onClose"];
}

export const PreviewResolutionSettings: React.FC<IPreviewResolutionSettingsProps> = ({
	className,
	open,
	target,
	onClose
}) => {
	const baseClass = BEM("edt-preview-resolution-settings");

	if (className) {
		baseClass.add(className);
	}

	return (
		<FieldFloatingPanel
			className={baseClass.toClassName()}
			for={target}
			isOpened={open}
			onClose={onClose}
			anchor={FC_ANCHOR.CENTER_BOTTOM}
			direction={FC_DIRECTION.HR}
			size={FC_SIZE.FIT_MIN}
			style={FIELD_FLOATING_PANEL_STYLE.STICKY}
			schema={FIELD_FLOATING_PANEL_SCHEMA.PRIMARY}
		>
			<PreviewResolutionSettingsForm />
		</FieldFloatingPanel>
	);
};
